import * as Action from './action';

const defineInitialState = () => ({
  id: null,
});

export function reducer(state = defineInitialState(), action) {
  switch (action.type) {
    case Action.$reset.ACTION:
      return defineInitialState();
    case Action.$save.ACTION:
      return {
        ...state,
        id: action?.payload,
      };
    default:
      return state;
  }
}

export function persister({ id }) {
  return {
    id,
  };
}
